<div class="container-fluid p-4">
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap-3">
          <a routerLink="/fire-foresight/burn-list" class="btn btn-outline-primary">
            <i class="bi bi-arrow-left"></i> Back
          </a>
          <h3 class="mb-0 h3" *ngIf="selectedRegion && selectedType">{{ selectedRegion.name }} - {{ selectedType.name }}</h3>
          <h3 class="mb-0 h3" *ngIf="selectedRegion && !selectedType">Region: {{ selectedRegion.name }}</h3>
          <h3 class="mb-0 h3" *ngIf="!selectedRegion && selectedType">Type: {{ selectedType.name }}</h3>
          <h3 class="mb-0 h3" *ngIf="!selectedRegionId && !selectedTypeId">All Burn Lists</h3>
        </div>
        <div class="text-end">
          <div class="badge bg-info fs-5 px-4 py-2">
            {{ filteredBurnLists.length }} Burn List{{ filteredBurnLists.length !== 1 ? 's' : '' }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Indicator -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Burn Lists Grid (4 columns for TV) -->
  <div *ngIf="!loading" class="row g-4">
    <div *ngFor="let burnList of filteredBurnLists" class="col-xl-3 col-lg-4 col-md-6">
      <div class="card h-100 shadow-sm border-0 bg-opacity-50"
           [ngClass]="getBurnPlanOverallFuelMoistureColor(burnList)">
        <!-- Status Header -->
        <div class="card-header text-white py-2">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="mb-0 fw-bold">{{ burnList.planName }}</h6>
            <i class="bi bi-fire fs-5"></i>
          </div>
        </div>

        <!-- Card Body -->
        <div class="card-body">

          <!-- Comments Count -->
          <div *ngIf="burnList.burnListComments && burnList.burnListComments.length > 0" class="mb-3">
            <div class="d-flex align-items-center">
              <i class="bi bi-chat-text text-muted me-2"></i>
              <small class="text-muted">
                {{ burnList.burnListComments.length }} comment{{ burnList.burnListComments.length !== 1 ? 's' : '' }}
              </small>
            </div>
          </div>

          <!-- Fuel Moisture Table -->
          <div *ngIf="getEnabledCoupsForBurn(burnList).length > 0" class="mt-3">
            <h6 class="mb-2">Fuel Moisture & Air Quality</h6>
            <div class="table-responsive">
              <table class="table table-sm table-bordered mb-0">
                <thead>
                  <tr>
                    <th class="text-center">Coup</th>
                    <th class="text-center" style="width: 80px;">Shade</th>
                    <th class="text-center" style="width: 80px;">Open</th>
                    <th class="text-center" style="width: 80px;">SDI</th>
                    <th class="text-center" style="width: 80px;">PM10</th>
                    <th class="text-center" style="width: 80px;">PM2.5</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let coup of getEnabledCoupsForBurn(burnList)">
                    <td class="align-middle">
                      <small>{{(coup.geoAsset?.identifier || 'Coup #' + coup.id) | uppercase}}</small>
                    </td>
                    <!-- Shade column -->
                    <td class="p-0 align-middle text-center"
                        [ngClass]="{'fuel-moisture-updated': hasFuelMoistureUpdated(coup.id, 'shaded')}"
                        [class]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true)"
                        [title]="getFuelMoistureShadedValue(coup.id) !== null ? 'Fuel Moisture (Shade): ' + getFuelMoistureShadedValue(coup.id) + '%' + (isFuelMoistureDataStale(coup.id, true) ? ' (Data older than 6 hours)' : '') : 'No data'">
                      <span class="w-100 d-block py-2"
                            [class.text-white]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true) !== 'bg-light'"
                            [class.text-dark]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureShadedValue(coup.id), true) === 'bg-light'">
                        <small *ngIf="getFuelMoistureShadedValue(coup.id) !== null">
                          <i class="bi bi-droplet-fill"></i> {{getFuelMoistureShadedValue(coup.id)}}%
                        </small>
                        <small *ngIf="getFuelMoistureShadedValue(coup.id) === null && !siteTwinsLoading">
                          N/A
                        </small>
                        <span *ngIf="getFuelMoistureShadedValue(coup.id) === null && siteTwinsLoading"
                              class="spinner-border spinner-border-sm"
                              role="status">
                        </span>
                      </span>
                    </td>
                    <!-- Open column -->
                    <td class="p-0 align-middle text-center"
                        [ngClass]="{'fuel-moisture-updated': hasFuelMoistureUpdated(coup.id, 'unshaded')}"
                        [class]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false)"
                        [title]="getFuelMoistureUnshadedValue(coup.id) !== null ? 'Fuel Moisture (Open): ' + getFuelMoistureUnshadedValue(coup.id) + '%' + (isFuelMoistureDataStale(coup.id, false) ? ' (Data older than 6 hours)' : '') : 'No data'">
                      <span class="w-100 d-block py-2"
                            [class.text-white]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false) !== 'bg-light'"
                            [class.text-dark]="getFuelMoistureBadgeClassWithStaleCheck(coup.id, getFuelMoistureUnshadedValue(coup.id), false) === 'bg-light'">
                        <small *ngIf="getFuelMoistureUnshadedValue(coup.id) !== null">
                          <i class="bi bi-droplet-fill"></i> {{getFuelMoistureUnshadedValue(coup.id)}}%
                        </small>
                        <small *ngIf="getFuelMoistureUnshadedValue(coup.id) === null && !siteTwinsLoading">
                          N/A
                        </small>
                        <span *ngIf="getFuelMoistureUnshadedValue(coup.id) === null && siteTwinsLoading"
                              class="spinner-border spinner-border-sm"
                              role="status">
                        </span>
                      </span>
                    </td>
                    <!-- SDI column -->
                    <td class="p-0 align-middle text-center"
                        [class]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id))"
                        [title]="getSDIValue(coup.id) !== null ? 'SDI: ' + getSDIValue(coup.id) + (isSDIDataStale(coup.id) ? ' (Data older than 6 hours)' : '') : 'No data'">
                      <span class="w-100 d-block py-2"
                            [class.text-white]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id)) !== 'bg-light'"
                            [class.text-dark]="getSDIBadgeClassWithStaleCheck(coup.id, getSDIValue(coup.id)) === 'bg-light'">
                        <small *ngIf="getSDIValue(coup.id) !== null">
                          {{getSDIValue(coup.id)}}
                        </small>
                        <small *ngIf="getSDIValue(coup.id) === null && !siteTwinsLoading">
                          N/A
                        </small>
                        <span *ngIf="getSDIValue(coup.id) === null && siteTwinsLoading"
                              class="spinner-border spinner-border-sm"
                              role="status">
                        </span>
                      </span>
                    </td>
                    <!-- PM10 column -->
                    <td class="p-0 align-middle text-center"
                        [class]="getPM10ColorForBurnCoup(coup.id)"
                        [title]="getPM10ValueForBurnCoup(coup.id) !== null ? 'PM10: ' + getPM10ValueForBurnCoup(coup.id)?.toFixed(1) + ' µg/m³' : 'No data'">
                      <span class="w-100 d-block py-2 text-white">
                        <small *ngIf="getPM10ValueForBurnCoup(coup.id) !== null">
                          <i class="bi bi-wind"></i> {{getPM10ValueForBurnCoup(coup.id)?.toFixed(1)}}
                        </small>
                        <small *ngIf="getPM10ValueForBurnCoup(coup.id) === null && !airQualitySitesLoading">
                          N/A
                        </small>
                        <span *ngIf="getPM10ValueForBurnCoup(coup.id) === null && airQualitySitesLoading"
                              class="spinner-border spinner-border-sm"
                              role="status">
                        </span>
                      </span>
                    </td>
                    <!-- PM2.5 column -->
                    <td class="p-0 align-middle text-center"
                        [class]="getPM25ColorForBurnCoup(coup.id)"
                        [title]="getPM25ValueForBurnCoup(coup.id) !== null ? 'PM2.5: ' + getPM25ValueForBurnCoup(coup.id)?.toFixed(1) + ' µg/m³' : 'No data'">
                      <span class="w-100 d-block py-2 text-white">
                        <small *ngIf="getPM25ValueForBurnCoup(coup.id) !== null">
                          <i class="bi bi-wind"></i> {{getPM25ValueForBurnCoup(coup.id)?.toFixed(1)}}
                        </small>
                        <small *ngIf="getPM25ValueForBurnCoup(coup.id) === null && !airQualitySitesLoading">
                          N/A
                        </small>
                        <span *ngIf="getPM25ValueForBurnCoup(coup.id) === null && airQualitySitesLoading"
                              class="spinner-border spinner-border-sm"
                              role="status">
                        </span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- No EPA Air Quality data message -->
          <div *ngIf="getNearbyAirQualitySites(burnList).length === 0 && getEnabledCoupsForBurn(burnList).length > 0" class="mt-3">
            <h6 class="mb-2">EPA Air Quality</h6>
            <div class="alert alert-secondary py-2 mb-0">
              <small class="text-muted">
                <i class="bi bi-info-circle me-1"></i>
                No EPA Air Quality stations available
              </small>
            </div>
          </div>

          <!-- Weather Station -->
          <div *ngIf="getEnabledCoupsForBurn(burnList).length > 0" class="mt-3">
            <h6 class="mb-2">Weather Station</h6>
            <div *ngIf="weatherStationSitesLoading" class="text-center p-2">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading weather data...</span>
              </div>
            </div>

            <div *ngIf="!weatherStationSitesLoading && !getNearestWeatherStation(burnList)" class="alert alert-secondary py-2 mb-0">
              <small class="text-muted">
                <i class="bi bi-info-circle me-1"></i>
                No weather station data available
              </small>
            </div>

            <div *ngIf="!weatherStationSitesLoading && getNearestWeatherStation(burnList)">
              <ng-container *ngIf="getNearestWeatherStation(burnList) as station">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-2">
                    <thead>
                      <tr>
                        <th style="width: 80px;">Temperature</th>
                        <th style="width: 80px;">Humidity</th>
                        <th style="width: 80px;">Wind Speed</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center align-middle"
                            [ngClass]="{'fuel-moisture-updated': hasWeatherStationUpdated(burnList.id, station, 'temp')}">
                          <div *ngIf="getTemperatureValue(station) !== null">
                            <div class="fw-bold">{{getTemperatureValue(station)?.toFixed(1)}}°C</div>
                            <div class="small mt-1" style="opacity: 0.9;">{{formatAge(getWindData(station).age)}}</div>
                          </div>
                          <small *ngIf="getTemperatureValue(station) === null" class="text-muted">N/A</small>
                        </td>
                        <td class="text-center align-middle"
                            [ngClass]="{'fuel-moisture-updated': hasWeatherStationUpdated(burnList.id, station, 'humidity')}">
                          <div *ngIf="getHumidityValue(station) !== null">
                            <div class="fw-bold">{{getHumidityValue(station)?.toFixed(0)}}%</div>
                            <div class="small mt-1" style="opacity: 0.9;">{{formatAge(getWindData(station).age)}}</div>
                          </div>
                          <small *ngIf="getHumidityValue(station) === null" class="text-muted">N/A</small>
                        </td>
                        <td class="text-center align-middle"
                            [ngClass]="{'fuel-moisture-updated': hasWeatherStationUpdated(burnList.id, station, 'windSpeed')}">
                          <div *ngIf="getWindSpeedValue(station) !== null">
                            <div class="fw-bold">{{getWindSpeedValue(station)?.toFixed(1)}} <small class="text-muted">km/h</small></div>
                            <div class="small mt-1" style="opacity: 0.9;">{{formatAge(getWindData(station).age)}}</div>
                          </div>
                          <small *ngIf="getWindSpeedValue(station) === null" class="text-muted">N/A</small>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <small class="text-muted d-block">
                  <i class="bi bi-geo-alt"></i> {{station.siteDescription || station.name || 'Unknown Station'}} (<small>{{station.distance.toFixed(1)}}km</small>)
                </small>
              </ng-container>
            </div>
          </div>

          <div *ngIf="getEnabledCoupsForBurn(burnList).length === 0" class="text-muted mt-3">
            <small>No coups assigned</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && filteredBurnLists.length === 0" class="text-center py-5">
    <i class="bi bi-inbox display-1 text-muted"></i>
    <h3 class="mt-3 text-muted">No Burn Lists Found</h3>
    <p class="text-muted" *ngIf="selectedRegionId">
      Try selecting a different region or view all regions.
    </p>
  </div>
</div>
